import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-separator',
  templateUrl: './text-separator.component.html',
  styleUrls: ['./text-separator.component.scss']
})
export class TextSeparatorComponent {
  @Input()
  text: string;
}
